import { defaultIconProps, IconProps } from './IconProps';

export const TrackingIcon: React.FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M8.00065 1.33325V3.99992M8.00065 11.9999V14.6666M4.00065 7.99992H1.33398M14.6673 7.99992H12.0007M12.7196 12.7189L10.834 10.8333M12.7196 3.33321L10.834 5.21883M3.2817 12.7189L5.16732 10.8333M3.2817 3.33321L5.16732 5.21883"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

TrackingIcon.defaultProps = defaultIconProps;
